import { useState } from 'react';
import { Position } from 'reactflow';
import { BaseNode, NodeField, NodeSelect, NodeTextarea } from './baseNode';

export const TransformNode = ({ id, data }) => {
  const [transformType, setTransformType] = useState(data?.transformType || 'uppercase');
  const [customCode, setCustomCode] = useState(data?.customCode || '');

  const handles = [
    { type: 'target', position: Position.Left,  id: `${id}-input` },
    { type: 'source', position: Position.Right, id: `${id}-output` },
  ];

  return (
    <BaseNode label="Transform" color="#0ea5e9" handles={handles}>
      <NodeField label="Operation">
        <NodeSelect value={transformType} onChange={e => setTransformType(e.target.value)}>
          <option value="uppercase">Uppercase</option>
          <option value="lowercase">Lowercase</option>
          <option value="trim">Trim whitespace</option>
          <option value="json_parse">Parse JSON</option>
          <option value="json_stringify">Stringify JSON</option>
          <option value="custom">Custom (JS)</option>
        </NodeSelect>
      </NodeField>
      {transformType === 'custom' && (
        <NodeField label="Custom JS">
          <NodeTextarea
            rows={3}
            value={customCode}
            onChange={e => setCustomCode(e.target.value)}
            placeholder="(input) => input.trim()"
          />
        </NodeField>
      )}
    </BaseNode>
  );
};